import { apiRequest } from '@/utils/api-request';
import { Test, CreateTestRequest } from '@/types/evals-types';
import { useOrgStore } from '@/stores/org-store';

export const createTest = async (body: CreateTestRequest): Promise<Test> => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;

  const response = await apiRequest<Test>({
    url: `/evaluations/test/${orgId}`,
    target: 'platform',
    method: 'POST',
    body: body as unknown as Record<string, unknown>,
  });
  return response?.data as Test;
};
